import { createRoute, redirect } from '@tanstack/react-router';

import { hasPermissionFactory } from '$/components/core/Authentication/hooks/useAuthorization';
import { useAuthenticationStore } from '$/components/core/Authentication/stores/useAuthenticationStore';
import { StudentsPage } from '$/pages/StudentsPage';
import { BaseRouteLayout } from '$/routes/Layouts/BaseRouteLayout';

export const StudentsRoute = createRoute({
  getParentRoute: () => BaseRouteLayout,
  path: '/students',
  component: StudentsPage,
  beforeLoad: () => {
    const { user } = useAuthenticationStore.getState();

    if (!hasPermissionFactory(user?.role ?? 'free')('School_See_Students')) {
      redirect({ to: '/not-allowed', throw: true });
    }
  },
});
